import { render, staticRenderFns } from "./safeguard.vue?vue&type=template&id=d2c6af06"
import script from "./safeguard.vue?vue&type=script&lang=js"
export * from "./safeguard.vue?vue&type=script&lang=js"
import style0 from "./safeguard.vue?vue&type=style&index=0&id=d2c6af06&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2c6af06')) {
      api.createRecord('d2c6af06', component.options)
    } else {
      api.reload('d2c6af06', component.options)
    }
    module.hot.accept("./safeguard.vue?vue&type=template&id=d2c6af06", function () {
      api.rerender('d2c6af06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/error-pages/safeguard.vue"
export default component.exports